import React from "react";

export const NoSound: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M32.7269 52.9136V73.9046H46.3632L63.4087 91.3971V35.4211L46.3632 52.9136H32.7269ZM56.5905 52.3189V74.4993L49.1928 66.9076H39.545V59.9106H49.1928L56.5905 52.3189ZM78.7496 63.4091C78.7496 57.2168 75.2723 51.8991 70.2269 49.3102V77.4731C75.2723 74.9192 78.7496 69.6015 78.7496 63.4091ZM70.2269 32.7273V39.9342C80.0791 42.9429 87.2723 52.3189 87.2723 63.4091C87.2723 74.4993 80.0791 83.8753 70.2269 86.884V94.0909C83.8973 90.9073 94.0905 78.3827 94.0905 63.4091C94.0905 48.4355 83.8973 35.9109 70.2269 32.7273Z"
      fill="#D1D5D9"
    />
    <circle
      cx="63.6066"
      cy="63.6066"
      r="41"
      transform="rotate(43.1548 63.6066 63.6066)"
      stroke="#E8ECEF"
      strokeWidth="8"
    />
    <path d="M92.7064 32.5693L33.947 95.2408" stroke="#E8ECEF" strokeWidth="4" />
  </svg>
);
